module.exports = " <div class=vux-tab :class=\"{'vux-tab-no-animate': !animate}\"> <slot></slot> <div v-if=animate class=vux-tab-ink-bar :class=barClass :style=barStyle></div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.7.0@vue-loader/lib/selector.js?type=template&index=0!./~/.0.1.3@vux/src/components/tab/tab.vue
// module id = 253
// module chunks = 2